import { DependencyList, EffectCallback, useEffect, useRef } from 'react'

const useDidUpdate = (effect: EffectCallback, deps?: DependencyList): void => {
  const mounted = useRef(false)

  useEffect(
    () => () => {
      mounted.current = false
    },
    [],
  )

  useEffect(() => {
    if (mounted.current) {
      return effect()
    }

    mounted.current = true
  }, deps)
}

export default useDidUpdate
